import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import SuperadminLayout, { DarkCard, Kpi } from "./SuperadminLayout";

export default function SuperadminMetrics() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/superadmin/metrics");
        setData(data);
      } finally { setLoading(false); }
    })();
  }, []);

  if (loading) return <SuperadminLayout title="Metrics produit"><p className="text-[#8494A8]">Chargement…</p></SuperadminLayout>;
  if (!data) return <SuperadminLayout title="Metrics produit"><p className="text-red-400">Erreur</p></SuperadminLayout>;

  const maxSent = Math.max(1, ...data.daily.map((d) => d.sent));

  return (
    <SuperadminLayout title="Metrics produit">
      <div className="grid grid-cols-3 gap-4 mb-6">
        <Kpi label="Envois total" value={data.total_sent.toLocaleString("fr-FR")} testid="metric-sent" />
        <Kpi label="Complétés" value={data.total_completed.toLocaleString("fr-FR")} testid="metric-completed" />
        <Kpi label="Taux de complétion" value={`${data.completion_rate}%`} sub="global, tous questionnaires" testid="metric-rate" />
      </div>

      <DarkCard className="p-6 mb-6" data-testid="daily-chart">
        <h2 className="text-lg font-semibold text-white mb-4">Envois quotidiens (30j)</h2>
        <div className="flex items-end gap-1 h-40">
          {data.daily.length === 0 ? (
            <p className="text-sm text-[#8494A8]">Aucune activité</p>
          ) : (
            data.daily.map((d) => (
              <div key={d.day} className="flex-1 flex flex-col justify-end items-center gap-0.5 group relative min-w-0">
                <div className="w-full flex flex-col justify-end" style={{ height: "100%" }}>
                  <div className="w-full bg-[#3A8FA5]/70 rounded-t" style={{ height: `${(d.completed / maxSent) * 100}%`, minHeight: d.completed > 0 ? "2px" : "0" }} />
                  <div className="w-full bg-[#E4572E]/60" style={{ height: `${((d.sent - d.completed) / maxSent) * 100}%`, minHeight: (d.sent - d.completed) > 0 ? "2px" : "0" }} />
                </div>
                <div className="absolute bottom-full mb-1 opacity-0 group-hover:opacity-100 bg-black/80 text-white text-[10px] px-2 py-1 rounded whitespace-nowrap z-10">
                  {d.day} · {d.completed}/{d.sent}
                </div>
              </div>
            ))
          )}
        </div>
        <div className="flex gap-4 mt-3 text-xs text-[#8494A8]">
          <span><span className="inline-block w-2 h-2 rounded-full bg-[#3A8FA5]/70 mr-1" /> Complétés</span>
          <span><span className="inline-block w-2 h-2 rounded-full bg-[#E4572E]/60 mr-1" /> En attente</span>
        </div>
      </DarkCard>

      <DarkCard className="overflow-hidden" data-testid="top-templates-table">
        <div className="px-6 py-4 border-b border-white/5">
          <h2 className="text-lg font-semibold text-white">Top questionnaires par usage</h2>
        </div>
        <table className="w-full text-sm">
          <thead className="bg-white/[0.03] text-[#8494A8]">
            <tr>
              <th className="text-left px-4 py-3 font-medium">Questionnaire</th>
              <th className="text-right px-4 py-3 font-medium">Envoyés</th>
              <th className="text-right px-4 py-3 font-medium">Complétés</th>
              <th className="text-right px-4 py-3 font-medium">Complétion</th>
            </tr>
          </thead>
          <tbody>
            {data.top_templates.length === 0 && <tr><td colSpan={4} className="p-8 text-center text-[#8494A8]">Pas encore d'activité</td></tr>}
            {data.top_templates.map((t) => (
              <tr key={t.template_id} className="border-t border-white/5 hover:bg-white/[0.03]">
                <td className="px-4 py-3 text-white text-sm">{t.title}</td>
                <td className="px-4 py-3 text-right text-white font-mono">{t.sent}</td>
                <td className="px-4 py-3 text-right text-white font-mono">{t.completed}</td>
                <td className="px-4 py-3 text-right text-white font-mono">{t.completion_rate}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </DarkCard>
    </SuperadminLayout>
  );
}
